import { useLocation } from "react-router-dom";

export const useIsThisLinkActive = (options = {}) => {
    const {matchLogic } = options
    const location = useLocation();

	const convertToString = location => {
		if(location?.pathname){
			return !matchLogic
                ? location.pathname + (location.search || '')
                : matchLogic === 'pathname-start-match'
                    && `/${location.pathname.split('/').filter(Boolean)[0]}`
		}else{
			return !matchLogic
                ? location
                : matchLogic === 'pathname-start-match'
                    && `/${location.split('/').filter(Boolean)[0]}`
		}
	}

    const isThisLinkActive = ({to}) => convertToString(to) === convertToString(location)

    const getActiveMenuOption = ({options}) => {
        let idx = options.findIndex((d) => d.to === convertToString(location))
        return idx !== -1 && options[idx]
    }

    return {isThisLinkActive, getActiveMenuOption }
	
}



